import fetcher, { fetchWithToken } from '@/services/fetcher'
import { buildQuery } from '@/utils/helpers'

// GraphQL mutations cho OTP
const REQUEST_UNIVERSAL_OTP = `
mutation RequestUniversalOtp($identifier: String!) {
  requestUniversalOtp(identifier: $identifier)
}
`

const VERIFY_UNIVERSAL_OTP = `
mutation VerifyUniversalOtp($identifier: String!, $otp: String!) {
  verifyUniversalOtp(identifier: $identifier, otp: $otp)
}
`

/**
 * Gửi OTP đến email hoặc số điện thoại
 * @param identifier - Email hoặc số điện thoại
 */
export const requestUniversalOtp = async (identifier: string) => {
  try {
    const response = await fetcher.post('', {
      query: REQUEST_UNIVERSAL_OTP,
      variables: { identifier },
    })

    const data = response?.payload?.data?.requestUniversalOtp
    if (response?.payload?.errors) {
      return { status: 'error', message: response.payload.errors[0]?.message }
    }

    return { status: 'success', data }
  } catch (error) {
    console.error('Error requesting OTP:', error)
    return { status: 'error', message: 'Có lỗi xảy ra khi gửi mã OTP' }
  }
}

/**
 * Xác thực OTP
 * @param identifier - Email hoặc số điện thoại
 * @param otp - Mã OTP
 */
export const verifyUniversalOtp = async (identifier: string, otp: string) => {
  try {
    const response = await fetcher.post('', {
      query: VERIFY_UNIVERSAL_OTP,
      variables: { identifier, otp },
    })

    const data = response?.payload?.data?.verifyUniversalOtp
    if (response?.payload?.errors) {
      return { status: 'error', message: response.payload.errors[0]?.message }
    }

    return { status: 'success', data }
  } catch (error) {
    console.error('Error verifying OTP:', error)
    return { status: 'error', message: 'Có lỗi xảy ra khi xác thực mã OTP' }
  }
}
